import React from 'react';
import styles from './FragmentMeasurments.module.css';
import { QuestionEntity } from '@entities/Question/Types';
import FragmentQuestionBlock from '@modules/Steps/Components/Step1/TemplateMeasurements/FragmentAndTemplateQuestionSection/FragmentMeasurments/FragmentQuestionBlock/FragmentQuestionBlock';
import { CustomProjectStep1ElementsIdsEnum } from '@modules/Steps/Shared/Enums/CustomProjectStep1ElementsIdsEnum';
import { useProjectStore } from '../../../../../../../Stores/ProjectStore';
import { useParams } from 'react-router-dom';
import { StepsViewModeEnum } from '@shared/Enums/StepsViewModeEnum';

interface Props {
    questions?: QuestionEntity[];
}

const FragmentMeasurements: React.FC<Props> = ({ questions }) => {
    const { updateQuestionInputValue, updateQuestionSelectValue } =
        useProjectStore();
    const { viewMode } = useParams();

    const handleUpdateQuestionInputValue = (
        questionUuid: string,
        value: string
    ) => {
        updateQuestionInputValue(questionUuid, value);
    };

    const handleUpdateQuestionSelectValue = (
        questionUuid: string,
        answerUuid: string
    ) => {
        return updateQuestionSelectValue(questionUuid, answerUuid);
    };

    return (
        <div className={styles.fragmentQuestions}>
            {questions?.map((question, index) => (
                <div
                    id={
                        index === 0
                            ? CustomProjectStep1ElementsIdsEnum.TEMPLATE_MEASUREMENTS_STEP1_FIELD
                            : undefined
                    }
                >
                    <FragmentQuestionBlock
                        key={`question-${index}`}
                        question={question}
                        updateQuestionInputValue={
                            handleUpdateQuestionInputValue
                        }
                        updateQuestionSelectValue={
                            handleUpdateQuestionSelectValue
                        }
                        isDisabled={viewMode === StepsViewModeEnum.PRESENTATION}
                    />
                </div>
            ))}
        </div>
    );
};

export default FragmentMeasurements;
